export const zh = {
  title: '工单系统',
  subtitle: '管理服务请求和问题处理',
  create: '新建工单',
  createDesc: '创建新的服务请求或问题报告',
  submit: '提交工单',
  recent: '最近工单',
  empty: '暂无工单',
  emptyDesc: '还没有任何工单',
  noFilterResult: '没有符合条件的工单',

  // 我的工单
  my: {
    title: '我的工单',
    subtitle: '查看和管理您的工单',
    created: '我创建的',
    assigned: '分配给我的',
    emptyCreated: '您还没有创建任何工单',
    emptyAssigned: '没有分配给您的工单',
  },

  // 列表
  list: {
    title: '工单列表',
    total: '共 {total} 个工单',
    desc: '查看和管理所有工单',
  },

  // 字段
  field: {
    title: '标题',
    description: '问题描述',
    category: '分类',
    priority: '优先级',
    status: '状态',
    assignee: '处理人',
    creator: '创建人',
    createdAt: '创建时间',
    tags: '标签',
    group: '处理组',
  },

  // 占位符
  placeholder: {
    title: '简要描述您的问题',
    description: '详细描述您遇到的问题，包括：\n- 问题现象\n- 发生时间\n- 已尝试的解决方法',
    category: '请选择分类',
    tags: '输入标签后按 Enter',
    categoryName: '请输入分类名称',
    groupName: '请输入处理组名称',
  },

  // 筛选
  filter: {
    allStatus: '全部状态',
    allPriority: '全部优先级',
    allCategory: '全部分类',
  },

  // 搜索
  search: {
    placeholder: '搜索工单标题、编号...',
  },

  // 状态
  status: {
    open: '新建',
    assigned: '已分配',
    inProgress: '处理中',
    pending: '挂起',
    resolved: '已解决',
    closed: '已关闭',
    cancelled: '已取消',
  },

  // 优先级
  priority: {
    low: '低',
    medium: '中',
    high: '高',
    urgent: '紧急',
  },

  // 来源
  source: {
    web: '网页',
    email: '邮件',
    phone: '电话',
    chat: '在线聊天',
    api: 'API',
  },

  // 统计
  stats: {
    total: '全部工单',
    open: '待处理',
    inProgress: '处理中',
    resolved: '已解决',
    today: '今日统计',
    todayCreated: '今日新建',
    todayResolved: '今日解决',
    slaRate: 'SLA 达成率',
    satisfaction: '满意度',
  },

  // 评论
  comment: {
    placeholder: '输入评论...',
  },

  // 验证
  validation: {
    titleRequired: '请输入工单标题',
    titleTooShort: '标题至少5个字符',
    descriptionRequired: '请输入问题描述',
    descriptionTooShort: '描述至少10个字符',
    categoryRequired: '请选择分类',
    categoryNameRequired: '请输入分类名称',
    categoryCodeRequired: '请输入分类编码',
    categoryCodeFormat: '编码必须以大写字母开头，只能包含大写字母、数字和下划线',
    codeExists: '编码已存在',
    groupNameRequired: '请输入处理组名称',
    groupCodeRequired: '请输入处理组编码',
    groupCodeFormat: '编码必须以大写字母开头，只能包含大写字母、数字和下划线',
  },

  // 分配策略
  assignmentStrategy: {
    roundRobin: '轮询分配',
    loadBalance: '负载均衡',
    manual: '手动分配',
    skillBased: '技能匹配',
  },

  // 提示
  tips: {
    title: '温馨提示',
    clear: '请尽可能详细地描述您的问题',
    category: '选择正确的分类有助于快速处理',
    priority: '紧急问题请选择"紧急"优先级',
  },

  // 成功消息
  success: {
    created: '工单创建成功',
    updated: '更新成功',
    deleted: '删除成功',
    statusUpdated: '状态已更新',
    commentAdded: '评论已添加',
    watched: '已关注',
    unwatched: '已取消关注',
    rated: '感谢您的评价',
  },

  // 错误消息
  error: {
    loadFailed: '加载失败',
    createFailed: '创建失败',
    updateFailed: '更新失败',
    deleteFailed: '删除失败',
    commentFailed: '评论失败',
    rateFailed: '评价失败',
    notFound: '工单不存在',
    loadCategoriesFailed: '加载分类失败',
    saveFailed: '保存失败',
  },

  // 确认
  confirm: {
    deleteCategory: '确定删除分类 "{name}" 吗？',
  },

  // 管理
  admin: {
    categories: '分类管理',
    groups: '处理组管理',
    stats: '统计分析',
  },

  // 导航
  nav: {
    overview: '工单概览',
    list: '工单列表',
    my: '我的工单',
    new: '新建工单',
  },

  // 概览页
  overview: {
    title: '工单概览',
    loading: '加载中...',
    newTicket: '新建工单',
    newTicketDesc: '创建新的服务请求或问题报告',
    allTickets: '全部工单',
    open: '待处理',
    inProgress: '处理中',
    resolved: '已解决',
    todayStats: '今日统计',
    todayCreated: '今日新建',
    todayResolved: '今日解决',
    slaRate: 'SLA 达成率',
    satisfaction: '满意度',
    quickActions: '快捷操作',
    myTickets: '我的工单',
    myTicketsDesc: '查看和管理您的工单',
    ticketList: '工单列表',
    ticketListDesc: '查看和管理所有工单',
    recentTickets: '最近工单',
    viewAll: '查看全部',
    noTickets: '暂无工单',
    noTicketsDesc: '还没有任何工单',
    assignee: '处理人',
  },

  // 新建工单页
  newTicket: {
    title: '新建工单',
    back: '返回',
    cancel: '取消',
    submit: '提交工单',
    submitting: '提交中...',
    titleLabel: '标题',
    titlePlaceholder: '简要描述您的问题',
    categoryLabel: '分类',
    categoryPlaceholder: '请选择分类',
    priorityLabel: '优先级',
    descriptionLabel: '问题描述',
    descriptionPlaceholder: '详细描述您遇到的问题，包括：\n- 问题现象\n- 发生时间\n- 已尝试的解决方法',
    tagsLabel: '标签',
    tagsOptional: '（可选，最多5个）',
    tagsPlaceholder: '输入标签后按 Enter',
    addTag: '添加',
    tipsTitle: '温馨提示',
    tip1: '请尽可能详细地描述您的问题',
    tip2: '选择正确的分类有助于快速处理',
    tip3: '紧急问题请选择"紧急"优先级',
    loadCategoriesFailed: '加载分类失败',
    createFailed: '创建失败',
  },

};

export default zh;
